import { all, takeLatest } from 'redux-saga/effects';
import { setThemeRequest } from './actions';
import { ThemeType } from './types';

function* themeContainer({ payload }: ReturnType<typeof setThemeRequest>) {}

export default all([takeLatest(ThemeType.SET_THEME_RESQUEST, themeContainer)]);
